import { FC } from "react";
import ReactAudioPlayer from "react-audio-player";

interface AudioPlayerProps {
  src: string;
  premium?: boolean;
  autoPlay?: boolean;
}
const AudioPlayerComponent: FC<AudioPlayerProps> = ({
  src,
  premium,
  autoPlay,
}) => {
  const styles = {
    width: "100%",
    border: premium ? "2px #1976d2 solid" : "",
    borderRadius: "25px",
  };
  return autoPlay ? (
    <ReactAudioPlayer src={src} controls style={styles} autoPlay />
  ) : (
    <ReactAudioPlayer src={src} controls style={styles} />
  );
};

export default AudioPlayerComponent;
